const tiers = [
  {
    band: "Under $30/day",
    adGroups: "1 tight ad group",
    matchTypes: "Exact match only",
    bidding: "Manual CPC",
    rationale: "Concentrate every click into one tight theme so signal compounds.",
  },
  {
    band: "$30 – $100/day",
    adGroups: "2 ad groups",
    matchTypes: "Exact + phrase",
    bidding: "Maximize conversions",
    rationale: "Two themes give Google enough data to start learning intent.",
  },
  {
    band: "$100 – $500/day",
    adGroups: "4 themed ad groups",
    matchTypes: "All match types",
    bidding: "Target CPA",
    rationale: "Enough volume to optimise to a cost-per-conversion target.",
  },
  {
    band: "$500+/day",
    adGroups: "6 ad groups",
    matchTypes: "All match types",
    bidding: "Target ROAS",
    rationale: "Full thematic coverage, bidding to revenue not conversions.",
  },
];

const McpBudgetTiers = () => {
  return (
    <section className="py-20 px-4 bg-background border-b border-border">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            Budget-aware structuring
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            The same prompt produces a structurally different campaign depending
            on your daily budget. This is the part other Google Ads MCPs don't
            do.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {tiers.map((t) => (
            <div
              key={t.band}
              className="rounded-lg border border-border bg-card text-card-foreground p-6 flex flex-col"
            >
              <div className="text-xs font-medium uppercase tracking-wider text-primary mb-2">
                {t.band}
              </div>
              <h3 className="font-semibold text-lg mb-4">{t.adGroups}</h3>
              <dl className="text-sm space-y-2 mb-4">
                <div>
                  <dt className="text-muted-foreground">Match types</dt>
                  <dd className="font-medium">{t.matchTypes}</dd>
                </div>
                <div>
                  <dt className="text-muted-foreground">Bidding</dt>
                  <dd className="font-medium">{t.bidding}</dd>
                </div>
              </dl>
              <p className="text-xs text-muted-foreground mt-auto">
                {t.rationale}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default McpBudgetTiers;
